import { canTrackCurrentPage } from "@/utils/analyticsConfig";

export interface GTMDataLayer {
  [key: string]: unknown;
}

export type GTMDataLayerEntry = GTMDataLayer | IArguments;

declare global {
  interface Window {
    dataLayer?: GTMDataLayerEntry[];
    gtag?: (...args: unknown[]) => void;
  }

  var dataLayer: GTMDataLayerEntry[] | undefined;
}

export const ensureDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

export const ensureGtag = () => {
  if (!window.gtag) {
    window.gtag = function gtag() {
      // GTM的gtag命令格式要求推送Arguments对象，而不是普通事件对象。
      // eslint-disable-next-line prefer-rest-params
      ensureDataLayer().push(arguments);
    };
  }

  return window.gtag;
};

export const setGtmDataLayer = (dataLayer: GTMDataLayer) => {
  if (!canTrackCurrentPage()) return false;

  ensureDataLayer().push(dataLayer);
  return true;
};

export const setGtagEvent = (
  eventName: string,
  parameters: GTMDataLayer,
) => {
  if (!canTrackCurrentPage()) return false;

  ensureGtag()("event", eventName, parameters);
  return true;
};
